import toPersianDigits from "~/utils/toPersianDigits";

export default function renderDigits({ data, options, i18n }: { data: number, options?: any, i18n: any }) {
  if (i18n?.dir?.() === "rtl") return toPersianDigits(data, options);
  else return data;
}
